const MAX_TORRENT_IMAGES = 5;

const sanitizeImageUrl = (value) => {
  if (typeof value !== "string") {
    return null;
  }

  const trimmedValue = value.trim();
  return trimmedValue || null;
};

export const getHighResImageUrl = (url) => {
  if (!url) return url;

  if (url.includes("i.imgur.com") || url.includes("imgur.com")) {
    return url.replace(/m\.(jpg|jpeg|png|gif|webp)$/i, ".$1");
  }

  return url;
};

export const getTorrentImageUrls = (torrent) => {
  if (!torrent) {
    return [];
  }

  const normalizedImageUrls = [];
  const rawImageUrls = [];

  if (typeof torrent === "string") {
    rawImageUrls.push(torrent);
  } else {
    if (Array.isArray(torrent.image_urls)) {
      rawImageUrls.push(...torrent.image_urls);
    }
    if (Array.isArray(torrent.imageUrls)) {
      rawImageUrls.push(...torrent.imageUrls);
    }
    if (Array.isArray(torrent.images)) {
      rawImageUrls.push(...torrent.images);
    }
    rawImageUrls.push(torrent.image_url, torrent.image);
  }

  for (const rawValue of rawImageUrls) {
    const sanitizedUrl = sanitizeImageUrl(rawValue);
    if (sanitizedUrl && !normalizedImageUrls.includes(sanitizedUrl)) {
      normalizedImageUrls.push(sanitizedUrl);
    }
  }

  return normalizedImageUrls.slice(0, MAX_TORRENT_IMAGES);
};

export const getPrimaryTorrentImageUrl = (torrent) =>
  getTorrentImageUrls(torrent)[0] || "";
